export const fixtureStateOnline = 'online';
export const fixtureStateOffline = 'offline';
export const fixtureStateUnknown = 'unknown';

export const fixtureStateState = [fixtureStateOnline, fixtureStateOffline] as const;
export type FixtureStateState = typeof fixtureStateState[number];
